import { Directive, input, output } from '@angular/core';

@Directive({
  selector: '[rsWebA11yPress]',
  standalone: true,
  host: {
    '[attr.tabindex]': 'focusable() ? 0 : -1',
    '(keydown.space)': "onPress($event, 'space')",
    '(keydown.enter)': "onPress($event, 'enter')",
    '(click)': "onPress($event, 'click')",
  },
})
export class A11yPressDirective {
  readonly allowedEvents = input(['space', 'enter', 'click']);
  readonly focusable = input(false);
  readonly press = output<KeyboardEvent | MouseEvent>();

  public onPress(event: Event, eventToCheck: string) {
    if (!this.allowedEvents().includes(eventToCheck)) return;
    if (event instanceof KeyboardEvent || event instanceof MouseEvent) {
      this.press.emit(event);
    }
  }
}
